module.exports = __webpack_public_path__ + "img/why-icon-2.e80a5d3a.svg";